import PropTypes from "prop-types";
import classNames from "classnames";
import RadioCircle from "../../../../RadioCircle/RadioCircle";
import classes from "./BranchListItem.module.css";

const BranchListItem = (props) => {
  const { onChange, checked, branchName, branchId } = props;

  return (
    <li
      className={classNames(classes["branch-list-item"], {
        [classes["branch-list-item--checked"]]: checked,
      })}
    >
      <input
        id={`${branchName}_${branchId}`}
        type="radio"
        value={branchId}
        name="branch"
        checked={checked}
        onChange={onChange}
        className="hidden"
      />
      <label
        htmlFor={`${branchName}_${branchId}`}
        className={classes["branch-list-item__label"]}
      >
        <RadioCircle checked={checked} />
        <p className={classes["branch-list-item__label-text"]}>{branchName}</p>
      </label>
    </li>
  );
};

export default BranchListItem;

BranchListItem.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  branchName: PropTypes.string,
  branchId: PropTypes.number,
};
